import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { selectUserInfo } from "../auth.ducks";
import { checkEmptyObject } from "../../../services";
import history from "../../../history";
import { VerifyModalI } from "../../../models/enums";
import { UserI } from "../../../typings/interfaces";
import VerifyModal from "../../../components/VerifyModal";
import styles from "../../../containers/App/app.scss";
import { getVerifyModalContent } from "../../../services/getVerifyModalContent";


export interface UserVerifyRequiredProps {
  history?: History;
  location?: Location;
  match?: { path: string; url: string; isExact: boolean; params: {} };
  staticContext?: any;
  user?: UserI | null;
}


const blankVerifyModal: VerifyModalI = {
  heading: "",
  content: "",
  redirectPath: ""
};

export default (Com: Function) => {
  const UserVerifyRequiredComponent = (props: UserVerifyRequiredProps) => {
    const { user } = props;

    const [verifyModal, setVerifyModal] = useState(blankVerifyModal);

    useEffect(() => {
      if (checkEmptyObject(user) && (!user.isVerified || !user.hasVerifiedPhoneNumber)) {
        setVerifyModal(getVerifyModalContent(user));
      }
    }, [user]);

    return checkEmptyObject(user) && user.isVerified && user.hasVerifiedPhoneNumber ? (
      <React.Fragment>
        <Com {...props} />
      </React.Fragment>
    ) : (
      <VerifyModal
        visible={verifyModal.heading !== "" && verifyModal.content !== "" && verifyModal.redirectPath !== ""}
        onOk={() => {
          history.push(verifyModal.redirectPath), setVerifyModal(blankVerifyModal);
        }}
        onCancel={() => {
          history.replace("/"), setVerifyModal(blankVerifyModal);
        }}
        onClose={() => setVerifyModal(blankVerifyModal)}
        closable={false}
        className={styles.modal}
        {...verifyModal}
      />
    );
  };

  return connect(
    state => ({
      user: selectUserInfo(state)
    }),
    null
  )(UserVerifyRequiredComponent);
};



// WEBPACK FOOTER //
// ./src/routes/Auth/HOCs/requireUserVerify.tsx